import { Component, Input } from '@angular/core';
import {fromSize, fromVisibility, Size, Visibility } from './../links-utils';

@Component({
    selector: 'a-link-icon',
    templateUrl: './a-link-icon.component.html',
    styleUrls: [
        '../links.scss',
        './a-link-icon.component.scss'
    ],
    standalone: false
})
export class ALinkIconComponent {
    @Input()
    public disabled: boolean = false;

    @Input()
    public noMargin: boolean = false;

    @Input()
    public collapse: boolean;

    @Input()
    public visibility: Visibility = 'LOW';

    @Input()
    public size: Size = 'DEFAULT';

    public fromVisibility = fromVisibility;
    public fromSize = fromSize;

    constructor() {
    }
}
